import AvailabilityCalendar from './AvailabilityCalendar';

export default AvailabilityCalendar;
